import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import jwt_decode from "jwt-decode";
import Cookies from 'universal-cookie';

import { fonts, colors, spacing, components } from "../../../constants/theme";
import primaryButton from "../../../assets/images/primary_button.png";
import primaryButtonHover from "../../../assets/images/primary_button_hover.png";
import { login } from "../../../api/authentication";
import { validateEmail } from "../../../utils/helpers";
import { INPUT_MAX_LENGTH, USER_TYPE } from "../../../constants/constants";
import { ONBOARDING_ROUTES, HOME_ROUTES } from "../../../constants/routes";
import { Header } from "../../../components/header";
import userIcon from "../../../assets/images/onboarding_icon.svg";

const queryString = require("query-string");

const cookies = new Cookies();

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: colors.greyLight,
    display: "block",
    width: "50%",
    margin: "0 auto",
    outline: 0,
    position: 'relative',
    padding: '20px 40px 80px 40px',
    borderRadius: 10,
    backgroundSize: '100% auto',
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '0 10px',
      maxHeight: '95%',
      backgroundImage: 'none',
      width: "90%",
      backgroundColor: "white",
    }
  },

  title: {
    ...components.commonTitle,
    width: "55%",
    margin: "0 auto",
    marginTop: spacing.xLarge,
    marginBottom: spacing.medium,
    display: "block",
    "& > img":{
      width: "40px",
      height: "40px",
      marginRight: "10px",
    },
    [theme.breakpoints.down('xs')]: {
      display: "none",
    },
  },

  subTitle: {
    fontFamily: fonts.subHeadingFontFamily,
    fontWeight: fonts.subHeadingFontWeight,
    color: colors.blueGrey,
    fontSize: '16px',
    lineHeight: 1.375,
    letterSpacing: -0.3,
    marginBottom: 40,
    marginTop: 32,
    [theme.breakpoints.down('xs')]: {
      marginTop: 10,
    },
  },

  form: {
    paddingTop: 20,
  },

  formControl: {
    width: '100%',
    marginBottom: '2em',
    backgroundColor: "white",
    '& .MuiOutlinedInput-input': {
      padding: '14px 14px',
      color: colors.blueGrey,
      fontSize: '14px',
      lineHeight: 1.42,
      fontFamily: fonts.bodyFontFamily,
      fontWeight: fonts.bodyFontWeight,
      [theme.breakpoints.down('xs')]: {
        fontSize: "16px",
      },
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.bluePale,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.bluePale,
      top: 0,
      '& legend': {
        display: 'none !important',
      }
    },
    '& .MuiOutlinedInput-root.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.bluePale,
        borderWidth: 1,
      }
    },
    '& .MuiInputLabel-root': {
      top: '-22px',
      fontFamily: fonts.subHeadingFontFamily,
      fontWeight: fonts.subHeadingFontWeight,
      fontSize: '14px',
      lineHeight: 1.43,
      color: colors.blueGrey,
      transform: 'none',
      '&.shrink': {
        transform: 'none'
      }
    },
  },

  inputError: {
    border: "1px solid red",
  },

  forgotPassword: {
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: 1.46,
    color: colors.blue,
    textDecoration: 'none',
    cursor: "pointer",
    [theme.breakpoints.down('xs')]: {
      lineHeight: 2,
    },
  },

  remember: {
    flexDirection: "row-reverse",
    marginRight: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      lineHeight: 1.42,
      color: colors.blueGrey,
      fontFamily: fonts.subHeadingFontFamily,
      fontWeight: fonts.subHeadingFontWeight,
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: "row",
    },
  },

  hr: {
    border: 'none',
    height: 1,
    marginTop: 28,
    marginBottom: 32,
    backgroundImage: 'linear-gradient(to right, #DEDEDE 33%, rgba(255,255,255,0) 0%)',
    backgroundPosition: 'bottom',
    backgroundSize: '3px 1px',
    backgroundRepeat: 'repeat-x',
    [theme.breakpoints.down('xs')]: {
      display: "none",
    },
  },

  button: {
    backgroundColor: "transparent",
    boxShadow: "none",
    marginTop: "auto",
    width: "330px",
    height: "45px",
    lineHeight: "45px",
    color: colors.blueDark,
    fontWeight: fonts.headingFontWeight,
    backgroundImage: `url(${primaryButton})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    textAlign: "center",
    cursor: "pointer",
    '& span': {
      display: "inline-block",
      verticalAlign: "middle",
      lineHeight: "normal",
      fontSize: "14px",
    },
    '&:hover': {
      backgroundImage: `url(${primaryButtonHover})`,
      backgroundColor: "transparent",
      boxShadow: "none",
      '& span': {
        color: colors.blue
      }
    },
  },

  leftArrow: components.commonLeftArrow,

  loginError: {
    width: "100%",
    margin: "0 auto",
    backgroundColor: colors.errorMessage,
    color: "white",
    textAlign: "left",
    padding: "15px",
  },

  bottomSection: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: "column-reverse",
    },
    "& > div": {
      [theme.breakpoints.down('xs')]: {
        maxWidth: "100%",
      },
    },
    "& button": {
      width: "70%",
      margin: "0 auto",
    },
  },

  forgotPasswordSection: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: "row-reverse",
      marginTop: "-30px",
      marginBottom: "30px",
      justifyContent: "space-between",
      "& > div": {
        justifyContent: "flex-end",
      },
    },
  },

  goBack: {
    margin: "20px 22%",
    [theme.breakpoints.down('xs')]: {
      margin: "20px 5%",
      alignItems: "end",
      maxWidth: "85%",
    },
  },

  registerNow: {
    margin: "30px 0px",
    display: "flex",
    justifyContent: "space-between",
    "& > span": {

    },
  },
}));

const Login = () => {
  const classes = useStyles();

  let params = queryString.parse(window.location.search);

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [rememberMe, setRememberMe] = useState(false);

  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loginError, setLoginError] = useState('');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onLogin();
    }
  };

  const onLogin = () => {
    let hasError=false;

    if(!validateEmail(email) || email.length > INPUT_MAX_LENGTH){
      setEmailError(true);
      hasError=true;
    }

    if(!password || password.length > INPUT_MAX_LENGTH){
      setPasswordError(true);
      hasError=true;
    }

    if(hasError) return;

    let data = {
      email: email,
      password: password,
      rememberMe: rememberMe,
    };

    login(data).then((response) => {
      if(response.data.status === "ERROR"){
        setLoginError(response.data.error);
        return;
      }
      let decoded = jwt_decode(response.data.token);
      localStorage.setItem("token", response.data.token);
      cookies.set('token', response.data.token, { domain: '.americanfootballinternational.com' });
      localStorage.setItem("userSlug", decoded.slug);
      cookies.set('userSlug', decoded.slug, { domain: '.americanfootballinternational.com' });
      localStorage.setItem("loggedIn", "true");
      cookies.set('loggedIn', 'true', { domain: '.americanfootballinternational.com' });
      if(params.redirect){
        window.location.href = `${window.location.protocol}//${window.location.hostname}${params.redirect}`;
      }
      else if(decoded.type == USER_TYPE.professional_team_manager || decoded.type == USER_TYPE.college_team_manager || decoded.type == USER_TYPE.fan){
        window.location.href = '/profile/basic_information';
      }else{
        window.location.href = `/profile/user_profile?user=${decoded.slug}`;
      }

    }).catch(e => {
      setLoginError(e.toString());
    });
  };

  return (
      <>
        <Header />
        <Typography className={classes.title} id="media"><img src={userIcon} alt="media icon" />LOGIN</Typography>
        <div className={classes.container}>
          <Grid container spacing={0}>
            {(loginError != '')?<div className={classes.loginError}>{loginError}</div>:null}
            <Grid item sm={12}>
              <h6 className={classes.subTitle}>Login with your Email</h6>
              <form noValidate className={classes.form}>
                <TextField id="email" label="Email" type="email" variant="outlined" className={(!emailError)?classes.formControl:classes.formControl + " " + classes.inputError} onChange={e => setEmail(e.target.value)}/>
                <TextField id="password" label="Password" type="password" variant="outlined" className={(!passwordError)?classes.formControl:classes.formControl + " " + classes.inputError} onChange={e => setPassword(e.target.value)} onKeyDown={e => handleKeyDown(e)}/>
                <Grid container className={classes.forgotPasswordSection}>
                  <Grid item xs={6} alignItems="center" container>
                    <a href={HOME_ROUTES.forgotPassword} className={classes.forgotPassword}>Forgot Password</a>
                  </Grid>
                  <Grid item xs={6} alignItems="center" container justify="flex-end">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={e => setRememberMe(!rememberMe)}
                          name="remember"
                          color="primary"
                          icon={<svg width="16px" height="16px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><path d="M3,0 C1.34314575,0 0,1.34314575 0,3 L0,21 C0,22.6568542 1.34314575,24 3,24 L21,24 C22.6568542,24 24,22.6568542 24,21 L24,3 C24,1.34314575 22.6568542,0 21,0 L3,0 Z" id="path-1"></path></defs><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Inputs/Checkbox/Unchecked" transform="translate(1.000000, 1.000000)"><mask id="mask-2" fill="white"><use xlinkHref="#path-1"></use></mask><path stroke="#CED6E9" d="M3,-0.5 L21,-0.5 C21.9664983,-0.5 22.8414983,-0.108249156 23.4748737,0.525126266 C24.1082492,1.15850169 24.5,2.03350169 24.5,3 L24.5,3 L24.5,21 C24.5,21.9664983 24.1082492,22.8414983 23.4748737,23.4748737 C22.8414983,24.1082492 21.9664983,24.5 21,24.5 L21,24.5 L3,24.5 C2.03350169,24.5 1.15850169,24.1082492 0.525126266,23.4748737 C-0.108249156,22.8414983 -0.5,21.9664983 -0.5,21 L-0.5,21 L-0.5,3 C-0.5,2.03350169 -0.108249156,1.15850169 0.525126266,0.525126266 C1.15850169,-0.108249156 2.03350169,-0.5 3,-0.5 L3,-0.5 Z"></path></g></g></svg>}
                          checkedIcon={<svg width="16px" height="16px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><rect id="path-1" x="-1" y="-1" width="26" height="26" rx="4"></rect><path d="M21,-1 C23.209139,-1 25,0.790861001 25,3 L25,21 C25,23.209139 23.209139,25 21,25 L3,25 C0.790861001,25 -1,23.209139 -1,21 L-1,3 C-1,0.790861001 0.790861001,-1 3,-1 L21,-1 Z M20.25,1 L3.75,1 C2.23121694,1 1,2.23121694 1,3.75 L1,20.25 C1,21.7687831 2.23121694,23 3.75,23 L20.25,23 C21.7687831,23 23,21.7687831 23,20.25 L23,3.75 C23,2.23121694 21.7687831,1 20.25,1 Z M19.8610443,5.92842527 C20.3157193,5.91023936 20.7329707,6.17451013 20.9116363,6.59281332 C21.0903073,7.01111651 20.9929415,7.49578182 20.6655679,7.81137847 C17.7426767,10.7405689 14.2731129,14.1972602 11.3535084,17.123438 C10.9490911,17.5299778 10.2996845,17.5567363 9.86426357,17.1833501 L9.86426357,17.1833501 L4.38658152,12.5273204 C4.16512979,12.339025 4.02711877,12.0704817 4.00358199,11.780548 C3.98005809,11.4906143 4.07312391,11.2028059 4.26141923,10.9813542 C4.44971455,10.7599024 4.71932606,10.6229596 5.00925977,10.5994228 C5.29919348,10.576967 5.58592549,10.6700328 5.80738543,10.8583282 L5.80738543,10.8583282 L10.5149054,14.8553928 C13.2835998,12.0823162 16.4141225,8.96261195 19.1080191,6.26227903 C19.3059551,6.05685226 19.5766074,5.93809776 19.8610443,5.92842527 Z" id="path-3"></path></defs><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Inputs/Checkbox/Checked" transform="translate(1.000000, 1.000000)"><mask id="mask-2" fill="white"><use xlinkHref="#path-1"></use></mask><use id="Mask" fill="#FFFFFF" xlinkHref="#path-1"></use><path d="M3,0 C1.34314575,0 0,1.34314575 0,3 L0,21 C0,22.6568542 1.34314575,24 3,24 L21,24 C22.6568542,24 24,22.6568542 24,21 L24,3 C24,1.34314575 22.6568542,0 21,0 L3,0 Z" id="Path" fill="#FFFFFF" mask="url(#mask-2)"></path><mask id="mask-4" fill="white"><use xlinkHref="#path-3"></use></mask><use id="Mask" fill="#FFFFFF" fillRule="nonzero" xlinkHref="#path-3"></use><g id="Group" mask="url(#mask-4)"><g transform="translate(-2.000000, -2.000000)" id="Colours/Blue"><rect id="Rectangle-21" fill="#4968FF" x="0" y="0" width="28" height="28"></rect></g></g></g></g></svg>}
                        />
                      }
                      label="Keep me logged in"
                      className={classes.remember}
                    />
                  </Grid>
                </Grid>
                <hr className={classes.hr} />
                <Grid container justify="center" className={classes.bottomSection}>
                  <Grid item xs={6} alignItems="center" container className={classes.registerNow}>
                    <span>Don't have an Account?</span>
                    <a href={ONBOARDING_ROUTES.createAccount} className={classes.forgotPassword}>Register Now</a>
                  </Grid>
                  <Button variant="contained" color="primary" className={classes.button} onClick={onLogin}>
                    Login
                  </Button>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>
        <Grid item xs={6} alignItems="center" container className={classes.goBack}>
            <span className={classes.leftArrow}> {'<'} </span><a href="/" className={classes.forgotPassword}>Return to home page</a>
        </Grid>
      </>
  );
}


export default Login;
